var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { apiGet } from "./api";
import { notifyNetworkError } from "./utils";
/*
 * High-level app configuration
 */
export var Environment;
(function (Environment) {
    Environment["DEV"] = "development";
    Environment["TEST"] = "test";
    Environment["PROD"] = "production";
})(Environment || (Environment = {}));
export const STATIC_CONFIG = {
    DEFAULT_NETWORK_NAME: "Mini City",
    ENV: process.env.NODE_ENV,
    API_ROOT: process.env.VUE_APP_API_ROOT,
    VERSION: process.env.VUE_APP_VERSION,
    SERVICE_ONLY_MODE: true,
};
export var MaintenanceMode;
(function (MaintenanceMode) {
    MaintenanceMode["OPEN"] = "OPEN";
    MaintenanceMode["CLOSED"] = "CLOSED";
    MaintenanceMode["ADMIN_ONLY"] = "ADMIN_ONLY";
})(MaintenanceMode || (MaintenanceMode = {}));
export const CONFIG = ref(null);
export const loadConfig = () => __awaiter(void 0, void 0, void 0, function* () {
    CONFIG.value = yield apiGet("/portal/caseworker/config")
        .catch(err => {
        notifyNetworkError("Failed to load portal configuration", err);
        return null;
    });
});
